import businessTaxForm from './business-tax-id.html';
import CommonApp from '../../app.js';
import {taxIdService} from '../../services/tax-id-service.js';

var TaxIdController = function($http, taxIdService) {
    var self = this;

    self.determineInputType = function() {
        var dataType = self.taxIdConfigs.allowData;
        if (dataType === 'numbers-only') {
            return 'tel';
        } else {
            return 'text';
        }
    };
    self.inputType = self.determineInputType();
    self.validateTaxId = function(form) {
        var validTaxId = self.taxIdValidator.isValidTaxId(self.taxId);
        form.taxId.$setValidity('validTaxId', validTaxId);
    };
    self.taxIdPossessionResponse = true;
    self.submitTaxIdAgreement = true;

    if (self.isAccountPage) {
        self.taxIdPossessionResponse = true;
    }
    self.showTaxIdPossessionFields = self.taxIdConfigs.showTaxIdPossessionFields;

    self.triggerTaxIdEmail = function() {
        taxIdService.triggerTaxIdEmail();
    };

    self.showSiretWarning = ((self.countryCode === 'FR') && self.isAccountPage && !self.taxId) ? true : false;
};

CommonApp.module.component('businessTaxId', {
    template: businessTaxForm,
    bindings: {
        taxIdConfigs: '=',
        countryCode: '=',
        taxIdValidator: '=',
        taxId: '=',
        maxLength: '=',
        hasToolTip: '=',
        translations: '=',
        isSubmitted: '=',
        taxIdPossessionResponse: '=',
        submitTaxIdAgreement: '=',
        emailInfoIsOpted: '=',
        isAccountPage: '<'
    },
    controller: TaxIdController,
    controllerAs: 'ctrl'
});



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/angular/components/tax-id/tax-id.js
// module id = 237
// module chunks = 0